import { useState, useCallback, useEffect, useRef } from "react";
import { api } from "../lib/api";

function read(key) {
  try { return JSON.parse(localStorage.getItem(key) || "[]"); } catch { return []; }
}
function write(key, val) {
  localStorage.setItem(key, JSON.stringify(val));
}

// Trim a station to the fields the backend expects.
function slim(s) {
  return {
    uid: s.uid, name: s.name, url: s.url, genre: s.genre || "",
    country: s.country || "", language: s.language || "", logo: s.logo || "",
    bitrate: s.bitrate || 0, codec: s.codec || "",
  };
}

export function useFavorites(email) {
  const key = `radioverse_fav_${email}`;
  const [favs, setFavs] = useState(() => read(key));
  const cloud = useRef(true);

  useEffect(() => {
    let active = true;
    api.get("/favorites")
      .then((r) => { if (!active) return; cloud.current = true; setFavs(r.data.favorites); write(key, r.data.favorites); })
      .catch((e) => { if (e?.response?.status === 503) { cloud.current = false; setFavs(read(key)); } });
    return () => { active = false; };
  }, [key]);

  const isFav = useCallback((uid) => favs.some((f) => f.uid === uid), [favs]);

  const toggle = useCallback((s) => {
    setFavs((prev) => {
      const exists = prev.some((f) => f.uid === s.uid);
      const next = exists ? prev.filter((f) => f.uid !== s.uid) : [slim(s), ...prev];
      write(key, next);
      if (cloud.current) {
        if (exists) api.delete(`/favorites/${s.uid}`).catch(() => {});
        else api.post("/favorites", slim(s)).catch(() => {});
      }
      return next;
    });
  }, [key]);

  return { favs, isFav, toggle };
}

export function useRecent(email) {
  const key = `radioverse_recent_${email}`;
  const [recent, setRecent] = useState(() => read(key));
  const cloud = useRef(true);

  useEffect(() => {
    let active = true;
    api.get("/recent")
      .then((r) => { if (!active) return; cloud.current = true; setRecent(r.data.recent); write(key, r.data.recent); })
      .catch((e) => { if (e?.response?.status === 503) { cloud.current = false; setRecent(read(key)); } });
    return () => { active = false; };
  }, [key]);

  const push = useCallback((s) => {
    setRecent((prev) => {
      const next = [slim(s), ...prev.filter((r) => r.uid !== s.uid)].slice(0, 30);
      write(key, next);
      if (cloud.current) api.post("/recent", slim(s)).catch(() => {});
      return next;
    });
  }, [key]);

  const clear = useCallback(() => {
    write(key, []);
    setRecent([]);
    if (cloud.current) api.delete("/recent").catch(() => {});
  }, [key]);

  return { recent, push, clear };
}
